<template>
    <div>
        <Header/>
        <div class="zwB "></div>
        <!--左侧开始-->
        <div class="bodyBG2">

            <!--面包屑开始-->
            <div class="curBoxb">
<!--                <a href="../../../../" title="首页" class="CurrChnlCls">首页</a>&nbsp;&gt;&nbsp;<a href="../../../"-->
<!--                                                                                               title="投资者关系"-->
<!--                                                                                               class="CurrChnlCls">投资者关系</a>&nbsp;&gt;&nbsp;<a-->
<!--                    href="../../" title="公司概况" class="CurrChnlCls">公司概况</a>&nbsp;&gt;&nbsp;<a href="../" title="公司介绍"-->
<!--                                                                                              class="CurrChnlCls">公司介绍</a>-->
                <BreadCrumb/>
            </div>
            <!--面包屑结束-->

            <!-- zcglBa s -->
            <div class="zcglBa">
                <div class="h1Div">公司概况</div>
                <!--<p>为各类机构和个人投资者提供多种证券投资增值服务</p>-->
            </div>
            <!-- zcglBa e -->

            <!--listPBa s-->
            <div class="listPBa">
                <CompanyIntroductionsLeftNav/>

                <!--右侧开始-->
                <div class="listPBr">

                    <!--curChnlName s-->
                    <div class="curChnlName">
                        公司制度
                        <!--	<div class="sjBox">
                                <div class="inpB"></div>
                                <input type="text" class="a" value="请输入关键字" />
                            </div>
                            -->
                    </div>
                    <!--curChnlName e-->


                    <ul class="listUla">

                        <li><span>2019-03-22</span><a target="_blank" href="./201903/P020190322655968205780.pdf">中信证券全面风险管理制度</a>
                        </li>

                        <li><span>2018-10-26</span><a target="_blank" href="./201810/t20181025_1028510.html">中信证券关联交易管理办法</a>
                        </li>

                        <li><span>2017-10-16</span><a target="_blank" href="./201710/U020200102618783681658.pdf">中信证券公司章程（2017年第一次修订）</a>
                        </li>

                        <li><span>2017-09-29</span><a target="_blank" href="./201710/U020200102668799466256.pdf">中信证券合规管理规定</a>
                        </li>

                        <li><span>2017-08-25</span><a target="_blank" href="./201710/U020200102667677952959.pdf">中信证券反洗钱管理办法</a>
                        </li>

                        <li><span>2016-10-28</span><a target="_blank" href="./201710/U020200103392161411906.pdf">中信证券信息披露暂缓与豁免管理制度</a>
                        </li>

                        <li><span>2016-04-30</span><a target="_blank" href="./201710/U020200102666252229911.pdf">中信证券董事会风险管理委员会议事规则</a>
                        </li>

                        <li><span>2016-04-30</span><a target="_blank" href="./201710/U020200102666800824354.pdf">中信证券全面风险管理制度</a>
                        </li>

                        <li><span>2016-04-30</span><a target="_blank"
                                                      href="http://www.cs.ecitic.com/news/newsContent.jsp?docId=4076191">中信证券董事会审计委员会议事规则</a>
                        </li>

                        <li><span>2015-08-04</span><a target="_blank" href="./201710/U020200102665513837496.pdf">中信证券公司章程（2015修订）</a>
                        </li>

                    </ul>

                    <div class="pagination">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="100">
                        </el-pagination>
                    </div>

                </div>
                <!--右侧结束-->
            </div>
            <!--listPBa e-->
        </div>
        <!--zxBd e-->
        <Footer/>
    </div>
</template>
<script>
    import Footer from "../components/Footer";
    import Header from "../components/Header";
    import CompanyIntroductionsLeftNav from "../components/CompanyIntroductionsLeftNav";
    import BreadCrumb from "../components/BreadCrumb";

    export default {
        components: {BreadCrumb, CompanyIntroductionsLeftNav, Footer, Header},
        mounted() {

        }
    }
</script>
<style lang="scss" scoped>
@import url('../css/2020_swiper.min.css');
@import url('../css/public_20200313v4.css');
@import url('../css/index.css');
@import url('../css/public_footer.css');
@import url('../css/zxStyle.css');
@import url('../css/zxPubliceStyle.css');
@import url('../css/shzr_zr2020.css');
</style>
<style>
    .zwB {
        height: 130px;
    }
    .pagination{
        padding: 20px 30px 20px 479px;
    }
</style>